// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oJdDrP9BMuN1iydVehSW {
  --letter-spacing: 0.178px;
  max-width: var(--campaign-tab-width);
  width: 100%;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .oJdDrP9BMuN1iydVehSW {
    --letter-spacing: 0.118px;
  }
}
.tGcqDmQnPFsfcWa6rHjd {
  --overview-container-vertical-gap: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--overview-container-vertical-gap);
  margin-bottom: 12px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .tGcqDmQnPFsfcWa6rHjd {
    --overview-container-vertical-gap: 4px;
    margin-bottom: 8px;
  }
}
.JCGkQmEuIKtZc_tuDuyO {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border: 1.5px solid #3F3F3F;
  background: #313131;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.7), 0 0 1.5px 1.5px #000;
  width: calc(50% - var(--overview-container-vertical-gap) / 2);
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .JCGkQmEuIKtZc_tuDuyO {
    gap: 8px;
    padding: 10px;
  }
}
.JCGkQmEuIKtZc_tuDuyO.OF55iFV9pjbXLv3vvaId {
  border-radius: 15px 0 0 15px;
}
.JCGkQmEuIKtZc_tuDuyO.L0HHhRFsdUSejTLZGm0L {
  border-radius: 0 15px 15px 0;
}
.JCGkQmEuIKtZc_tuDuyO.L0HHhRFsdUSejTLZGm0L .T4EemKZ1DYG_Bj8vzeKm {
  color: #FFDF1A;
}
.c9QSt7WBU48KdHleBesl {
  text-transform: uppercase;
  font-size: 22px;
  line-height: 0.7;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .c9QSt7WBU48KdHleBesl {
    font-size: 15px;
    line-height: 0.8;
  }
}
.T4EemKZ1DYG_Bj8vzeKm {
  font-family: var(--font-family-secondary);
  font-weight: 800;
  font-size: 34px;
  line-height: 0.7;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .T4EemKZ1DYG_Bj8vzeKm {
    font-size: 23px;
  }
}
.uazv6JrCJJhcNiLRH1yL {
  font-size: 19px;
  margin-left: 1px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .uazv6JrCJJhcNiLRH1yL {
    font-size: 13px;
  }
}
.K8AJJEtDuyT4amPc4vL_ {
  height: 60px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .K8AJJEtDuyT4amPc4vL_ {
    height: 40px;
  }
}
.QqZZM4mVOh5hE_LqC7vM {
  flex-direction: column;
  gap: 9px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .QqZZM4mVOh5hE_LqC7vM {
    gap: 6px;
  }
}
.hjqIsuE0hKTX5H3NbbHJ {
  font-size: 22px;
  font-weight: 700;
  line-height: 15px;
  letter-spacing: var(--letter-spacing);
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .hjqIsuE0hKTX5H3NbbHJ {
    font-size: 15px;
    line-height: 10px;
  }
}
.qPVHDMjMezIQhE8C5lUJ {
  color: #C3C3C3;
  font-family: var(--font-family-primary);
  font-size: 14px;
  line-height: 1;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .qPVHDMjMezIQhE8C5lUJ {
    font-size: 9px;
  }
}
.FTERPvBjtmAb8u3bw_UJ {
  display: flex;
  align-items: center;
  justify-content: center;
}
.crQy7UqR0qGfomDKYMry {
  height: 36px;
  width: 36px;
  margin-right: 10px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .crQy7UqR0qGfomDKYMry {
    height: 24px;
    width: 24px;
    margin-right: 7px;
  }
}
.DK1kfmeDgo0G297AK9U2 {
  filter: drop-shadow(0 0 4px rgba(60, 255, 0, 0.5));
}
.HvkIAvVJK25Iuk0upBCu {
  color: #D4D4D4;
  font-size: 22px;
  font-family: var(--font-family-secondary);
  font-weight: 700;
  letter-spacing: var(--letter-spacing);
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .HvkIAvVJK25Iuk0upBCu {
    font-size: 15px;
  }
}
.HcupnQl5fOR3LUwlw6TS {
  flex-direction: column;
  align-items: flex-end;
}
.N8hfIrLaEAogxB1ubnIl {
  color: #D4D4D4;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: var(--letter-spacing);
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .N8hfIrLaEAogxB1ubnIl {
    font-size: 15px;
    line-height: 18px;
  }
}
.N8hfIrLaEAogxB1ubnIl span {
  font-size: 14px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .N8hfIrLaEAogxB1ubnIl span {
    font-size: 9px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/rebate/tabs/WinningsTab/WinningsTab.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,WAAW;AACb;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;AACrB;AACA;EACE;IACE,sCAAsC;IACtC,kBAAkB;EACpB;AACF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,8DAA8D;EAC9D,6DAA6D;AAC/D;AACA;EACE;IACE,QAAQ;IACR,aAAa;EACf;AACF;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;AACvC;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;EACnB;AACF;AACA;EACE,kDAAkD;AACpD;AACA;EACE,cAAc;EACd,eAAe;EACf,yCAAyC;EACzC,gBAAgB;EAChB,qCAAqC;AACvC;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".winningsTabWrapper {\n  --letter-spacing: 0.178px;\n  max-width: var(--campaign-tab-width);\n  width: 100%;\n}\n@media (--campaign-mobile) {\n  .winningsTabWrapper {\n    --letter-spacing: 0.118px;\n  }\n}\n.overviewContainer {\n  --overview-container-vertical-gap: 6px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: var(--overview-container-vertical-gap);\n  margin-bottom: 12px;\n}\n@media (--campaign-mobile) {\n  .overviewContainer {\n    --overview-container-vertical-gap: 4px;\n    margin-bottom: 8px;\n  }\n}\n.overviewContainerCell {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  border: 1.5px solid #3F3F3F;\n  background: #313131;\n  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.7), 0 0 1.5px 1.5px #000;\n  width: calc(50% - var(--overview-container-vertical-gap) / 2);\n}\n@media (--campaign-mobile) {\n  .overviewContainerCell {\n    gap: 8px;\n    padding: 10px;\n  }\n}\n.overviewContainerCell.left {\n  border-radius: 15px 0 0 15px;\n}\n.overviewContainerCell.right {\n  border-radius: 0 15px 15px 0;\n}\n.overviewContainerCell.right .overviewCellData {\n  color: #FFDF1A;\n}\n.overviewCellHeading {\n  text-transform: uppercase;\n  font-size: 22px;\n  line-height: 0.7;\n}\n@media (--campaign-mobile) {\n  .overviewCellHeading {\n    font-size: 15px;\n    line-height: 0.8;\n  }\n}\n.overviewCellData {\n  font-family: var(--font-family-secondary);\n  font-weight: 800;\n  font-size: 34px;\n  line-height: 0.7;\n}\n@media (--campaign-mobile) {\n  .overviewCellData {\n    font-size: 23px;\n  }\n}\n.overviewCellCurrency {\n  font-size: 19px;\n  margin-left: 1px;\n}\n@media (--campaign-mobile) {\n  .overviewCellCurrency {\n    font-size: 13px;\n  }\n}\n.tableRow {\n  height: 60px;\n}\n@media (--campaign-mobile) {\n  .tableRow {\n    height: 40px;\n  }\n}\n.levelsCellContainer {\n  flex-direction: column;\n  gap: 9px;\n}\n@media (--campaign-mobile) {\n  .levelsCellContainer {\n    gap: 6px;\n  }\n}\n.levelsCellTop {\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 15px;\n  letter-spacing: var(--letter-spacing);\n}\n@media (--campaign-mobile) {\n  .levelsCellTop {\n    font-size: 15px;\n    line-height: 10px;\n  }\n}\n.levelsCellBottom {\n  color: #C3C3C3;\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  line-height: 1;\n}\n@media (--campaign-mobile) {\n  .levelsCellBottom {\n    font-size: 9px;\n  }\n}\n.percentageCell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.levelIcon {\n  height: 36px;\n  width: 36px;\n  margin-right: 10px;\n}\n@media (--campaign-mobile) {\n  .levelIcon {\n    height: 24px;\n    width: 24px;\n    margin-right: 7px;\n  }\n}\n.levelIconUnlocked {\n  filter: drop-shadow(0 0 4px rgba(60, 255, 0, 0.5));\n}\n.percentage {\n  color: #D4D4D4;\n  font-size: 22px;\n  font-family: var(--font-family-secondary);\n  font-weight: 700;\n  letter-spacing: var(--letter-spacing);\n}\n@media (--campaign-mobile) {\n  .percentage {\n    font-size: 15px;\n  }\n}\n.maxWinCell {\n  flex-direction: column;\n  align-items: flex-end;\n}\n.maxWin {\n  color: #D4D4D4;\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: var(--letter-spacing);\n}\n@media (--campaign-mobile) {\n  .maxWin {\n    font-size: 15px;\n    line-height: 18px;\n  }\n}\n.maxWin span {\n  font-size: 14px;\n}\n@media (--campaign-mobile) {\n  .maxWin span {\n    font-size: 9px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"winningsTabWrapper": `oJdDrP9BMuN1iydVehSW`,
	"overviewContainer": `tGcqDmQnPFsfcWa6rHjd`,
	"overviewContainerCell": `JCGkQmEuIKtZc_tuDuyO`,
	"left": `OF55iFV9pjbXLv3vvaId`,
	"right": `L0HHhRFsdUSejTLZGm0L`,
	"overviewCellData": `T4EemKZ1DYG_Bj8vzeKm`,
	"overviewCellHeading": `c9QSt7WBU48KdHleBesl`,
	"overviewCellCurrency": `uazv6JrCJJhcNiLRH1yL`,
	"tableRow": `K8AJJEtDuyT4amPc4vL_`,
	"levelsCellContainer": `QqZZM4mVOh5hE_LqC7vM`,
	"levelsCellTop": `hjqIsuE0hKTX5H3NbbHJ`,
	"levelsCellBottom": `qPVHDMjMezIQhE8C5lUJ`,
	"percentageCell": `FTERPvBjtmAb8u3bw_UJ`,
	"levelIcon": `crQy7UqR0qGfomDKYMry`,
	"levelIconUnlocked": `DK1kfmeDgo0G297AK9U2`,
	"percentage": `HvkIAvVJK25Iuk0upBCu`,
	"maxWinCell": `HcupnQl5fOR3LUwlw6TS`,
	"maxWin": `N8hfIrLaEAogxB1ubnIl`
};
export default ___CSS_LOADER_EXPORT___;
